import script from "./CelulaGrade.vue?vue&type=script&setup=true&lang=js"
export * from "./CelulaGrade.vue?vue&type=script&setup=true&lang=js"

import "./CelulaGrade.vue?vue&type=style&index=0&id=e518be80&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e518be80"]])

export default __exports__